var patch = require("./vdom/patch.js")

module.exports = patch



//////////////////
// WEBPACK FOOTER
// C:/Users/tomas/OneDrive/Tomas/Materials/Talks/2018/live-compilers/code/completed/node_modules/virtual-dom/patch.js
// module id = 45
// module chunks = 0